import React from 'react';
import { UrgencyBanner } from './components/UrgencyBanner';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { PackContentsSection } from './components/PackContentsSection';
import { ProductPreviewSection } from './components/ProductPreviewSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { PricingSection } from './components/PricingSection';
import { ClosingSection } from './components/ClosingSection';
import { Footer } from './components/Footer';
export function App() {
  return <main className="min-h-screen w-full bg-[#F9F9F9] text-[#1A1A1A] font-montserrat selection:bg-[#00BCD4] selection:text-white" data-id="element-0">
      <UrgencyBanner data-id="element-1" />
      <HeroSection data-id="element-2" />
      <ProblemSection data-id="element-3" />
      <PackContentsSection data-id="element-4" />
      <ProductPreviewSection data-id="element-5" />
      <TestimonialsSection data-id="element-6" />
      <PricingSection data-id="element-7" />
      <ClosingSection data-id="element-8" />
      <Footer data-id="element-9" />
    </main>;
}